import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BomLine } from '../../../api/models/bom-line';

@Component({
  selector: 'app-bom-csv-error',
  templateUrl: './bom-csv-upload-error.component.html',
  styleUrls: ['./bom-csv-upload-error.component.scss']
})
export class BomCsvUploadErrorComponent implements OnInit {

  @Input() bomLines: BomLine[] = [];

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/bom-csv-upload-error/bom-csv-upload-error.component.ts